import {ConcreteLayer} from "../classes/concreteLayers/ConcreteLayer";

export var concreteFigures = new Map<number, any>();
